import React, { useEffect, useState } from "react";
import { FlatList, Dimensions, View } from "react-native";
import { useSelector } from "react-redux";
import Spinner from "../Spinner";
import { Text } from "../Text";
import { MenuItem, Product } from "../../types/product";
import ProductCard from "./ProductCard";
import {
  getMenuItemsByCurrentFilterCategory,
  getMenuProductsLoading,
} from "@/app/selectors/menuItem";
import { emptyProductListStyles, spinnerStyles } from "./styles";
import { getSelectedFilter } from "@/app/selectors/config";
import { useTranslateText } from "@/app/utils/translations";

const windowWidth = Dimensions.get("window").width;
const windowHeight = Dimensions.get("window").height;

type ProductListProps = {
  onItemPress: (item: Product, isCombo: boolean) => void;
};

const renderItem = (
  isFiltered: boolean | undefined,
  onItemPress: (item: Product, isCombo: boolean) => void,
  item: MenuItem,
) => {
  if (
    isFiltered &&
    item.filterHeight &&
    item.filterWidth &&
    item.filterImageUrl
  ) {
    return (
      <ProductCard
        height={windowHeight / 5 - 25}
        width={windowWidth / 8 - 22}
        imageUrl={item.filterImageUrl}
        onItemPress={onItemPress}
        product={item.product}
        isCombo={item.isCombo}
      />
    );
  } else {
    return (
      <ProductCard
        height={windowHeight / 5 - 25}
        width={windowWidth / 5}
        imageUrl={item.imageUrl}
        onItemPress={onItemPress}
        product={item.product}
        isCombo={item.isCombo}
      />
    );
  }
};

const ProductList = ({ onItemPress }: ProductListProps) => {
  const { t } = useTranslateText();
  const [filteredProducts, setFilteredProducts] = useState<MenuItem[]>([]);
  const selectedFilter = useSelector(getSelectedFilter);
  const products = useSelector(getMenuItemsByCurrentFilterCategory);
  const productsLoading = useSelector(getMenuProductsLoading);
  const isFiltered = !!selectedFilter && selectedFilter !== "all";

  useEffect(() => {
    if (products && products.length > 0) {
      if (!isFiltered) {
        setFilteredProducts(products.slice(0, 25));
      } else if (selectedFilter) {
        setFilteredProducts(products);
      }
    }
  }, [isFiltered, products, selectedFilter]);

  if (productsLoading) {
    return <Spinner styles={spinnerStyles} theme="dark" size="large" />;
  }

  if (!products || products.length === 0) {
    return (
      <View style={spinnerStyles.container} testID="productListEmpty">
        <Text style={emptyProductListStyles.message}>
          {t("tpos.productArea.noItemsInCategory")}
        </Text>
      </View>
    );
  }

  return (
    <FlatList
      testID="productList"
      data={filteredProducts}
      keyExtractor={({ product }) => `${product.id}`}
      renderItem={({ item }) => renderItem(isFiltered, onItemPress, item)}
      numColumns={5}
    />
  );
};

export default ProductList;
